var _a;
import * as tabs from '@zag-js/tabs';
import { createContext } from '../../internal/create-context.js';
export var setTabContext = (_a = createContext({
    fluid: false,
    api: {}
}), _a[0]), getTabContext = _a[1], key = _a[2];
